export default "__VITE_ASSET__4e140cba__"